import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import { USABLE_ICONS } from "variables/constants";
import { Zap } from "lucide-react"
import HeaderComponent from "components/card/HeaderComponent";
import {
  getAutoRewardList
} from "../../../../../redux/reward/rewardState";
import { Pagination } from "antd";

const MilestoneSummary = ({ }) => {

  const dispatch = useDispatch();

  const recordList = useSelector((state) => state.reward.autoRewardList?.items);
  const pagination = useSelector((state) => state.reward.autoRewardList?.pagination);
  const filters = useSelector((state) => state.reward.autoRewardList?.filters);

  const doSearch = (filters) => dispatch(getAutoRewardList(filters));

  useEffect(() => {
    dispatch(getAutoRewardList({ paginate: pagination?.per_page || 10 }));
  }, [dispatch, pagination?.per_page]);

  return (
    <HeaderComponent
      title="Automatic Milestone Rewards"
      titleClass="text-[16px] font-medium"
      description="Select an award category to nominate a team member"
      descriptionClass="text-sm text-slate-700"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {recordList.map((item) => {
          const Icon = USABLE_ICONS[item.rwd_icon] ?? '';
            return (
              <Card 
                key={item.rwd_id}
                className={`card-theme p-5 ${item.rwd_color_class}`}
              >
                <div className="space-y-3">
                  <div className="flex flex-col items-start gap-3">
                    <div className="inline-flex items-start justify-between w-full">
                      <div className="icon-style p-3 text-white">
                        { <Icon className="h-6 w-6" />}
                      </div>
                      <div>
                        <span className="border status-color font-medium rounded-xl px-1 py-0.5 text-xs">
                          {item.rwd_title === "Work Anniversary" ? `${item.rwd_points} per year pts` : `${item.rwd_points} pts`}
                        </span>
                      </div>
                    </div>
                    <h4 className="card-text text-base">{item.rwd_title}</h4>
                    <p className="text-[13px] muted-text">{item.rwd_description}</p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
        <div className="text-card-foreground flex flex-col gap-6 rounded-xl border mt-4 border-emerald-200 bg-emerald-50 dark:border-emerald-700 dark:bg-emerald-900">
          <div className="p-5 inline-flex items-center">
            <div className="flex gap-3">
              <Zap className="w-5 h-5 text-emerald-600 dark:text-emerald-500"/>
            <div>
              <p className="text-[13px] font-medium text-emerald-900 dark:text-emerald-50">Fully Automated</p>
              <p className="text-[12px] text-emerald-700 dark:text-emerald-200">
                These milestone rewards are automatically credited to employee accounts. No manual action required from management.
              </p>
            </div>
          </div>
        </div>
      </div>
      {pagination?.total > pagination?.per_page && (
        <div className="flex justify-end py-4">
          <Pagination
            current={pagination?.current_page}
            pageSize={pagination?.per_page}
            total={pagination?.total}
            showSizeChanger={false}
            onChange={(page) =>
              doSearch({
                ...filters,
                page,
                paginate: pagination?.per_page,
              })
            }
          />
        </div>
      )}
    </HeaderComponent>
  );
};

export default MilestoneSummary;
